<template>
  <smooth-scrollbar>
    <div class="group-list" style="margin:0 1.4rem;height:55vh">
      <group v-for="(group,i) in orthos" :group="group" :key="i" :index="i"></group>
    </div>
  </smooth-scrollbar>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Group from "./group.component";
export default {
  components: {
    Group
  },
  computed: {
    ...mapState(["orthos"])
  }
};
</script>
